import { MultiColumnFormFields } from "@components/common/form/FormFields";
import { PeekButton, PeekStack, PeekTypography, useTheme } from "@piiqtechnologies/ui-components";
import { useAnalytics, useError, useLoader, useNotification, useRefetch, useUpdateSpace, } from "@piiqtechnologies/ui-lib";
import { Form, Formik } from "formik";
import React, { useEffect, useMemo } from "react";
import { useIntl } from "react-intl";
import { getSpaceSettingsFormFields, SpaceSettingsFormInitialValue, SpaceSettingsFormValidationSchema, } from "./AmenitySettingsConfig";
import messages from "./messages.i18n";
export const AmenitySpaceSettings = ({ spaceDetails }) => {
    const SettingsFormFields = getSpaceSettingsFormFields();
    const [updateSpaceDetails, spaceDetailsUpdated, updateSpaceDetailsInProgress, updateSpaceDetailsError] = useUpdateSpace();
    const { setNotification } = useNotification();
    const { setError } = useError();
    const { setLoader } = useLoader();
    const { setRefetch } = useRefetch();
    const intl = useIntl();
    const theme = useTheme();
    const analytics = useAnalytics();
    const handleSpaceSettingsUpdate = (values) => {
        updateSpaceDetails(Object.assign(Object.assign({}, values), { _id: spaceDetails._id }));
    };
    useEffect(() => {
        setLoader(updateSpaceDetailsInProgress);
        return () => setLoader(false);
    }, [updateSpaceDetailsInProgress]);
    useEffect(() => {
        if (updateSpaceDetailsError) {
            setError(updateSpaceDetailsError === null || updateSpaceDetailsError === void 0 ? void 0 : updateSpaceDetailsError.message);
        }
    }, [updateSpaceDetailsError]);
    useEffect(() => {
        if (spaceDetailsUpdated) {
            setNotification(intl.formatMessage(messages.updateSpaceSettingsSuccess));
            analytics.track("Space Details Updated");
            setRefetch();
        }
    }, [spaceDetailsUpdated]);
    const spaceSettingsInitialValues = useMemo(() => {
        if (!spaceDetails) {
            return SpaceSettingsFormInitialValue;
        }
        const { unit } = spaceDetails;
        return Object.assign(Object.assign({}, SpaceSettingsFormInitialValue), { unit });
    }, [spaceDetails]);
    return (React.createElement(PeekStack, { direction: "column", spacing: 1 },
        React.createElement(PeekTypography, { variant: "h3", fontWeight: theme.typography.fontWeightMedium }, intl.formatMessage(messages.updateSpaceTitle)),
        React.createElement(Formik, { initialValues: spaceSettingsInitialValues, validationSchema: SpaceSettingsFormValidationSchema(), enableReinitialize: true, onSubmit: handleSpaceSettingsUpdate },
            React.createElement(Form, null,
                React.createElement(PeekStack, { spacing: 2, pt: { xs: 2.5, md: 0 }, direction: "column", justifyContent: "space-between", sx: { mt: 0 } },
                    React.createElement(MultiColumnFormFields, { fields: SettingsFormFields }),
                    React.createElement(PeekButton, { variant: "contained", size: "large", fullWidth: true, color: "primary", type: "submit" }, intl.formatMessage(messages.update)))))));
};
export default AmenitySpaceSettings;
